/*
  PDP accordions: one open at a time, with the open and close animated.

  <details> cannot animate on its own — the browser shows and hides the content
  in a single frame — so the click is intercepted and the height driven here,
  with `open` held on until the closing animation has finished. Without JS the
  accordions still work, just instantly and without the exclusivity, which is
  the native behaviour.
*/
(function () {
  'use strict';

  var DURATION = 320;

  function reduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function content(details) {
    return details.querySelector('.accordion__content');
  }

  function setup(wrap) {
    if (wrap.paReady) return;
    wrap.paReady = true;

    var details = wrap.querySelector('details');
    var summary = details && details.querySelector('summary');
    var body = details && content(details);
    if (!details || !summary || !body) return;

    // The group is every PDP accordion sharing a parent, so a product with two
    // separate runs of them closes within each run rather than across both.
    function siblings() {
      var all = wrap.parentElement
        ? wrap.parentElement.querySelectorAll(':scope > .product__accordion')
        : [];
      return Array.prototype.filter.call(all, function (el) {
        return el !== wrap;
      });
    }

    function animate(el, from, to, after) {
      el.style.height = from + 'px';
      // Force the start height to be painted, or both values collapse into one
      // style change and nothing animates.
      void el.offsetHeight;
      el.style.transition = 'height ' + DURATION + 'ms cubic-bezier(0.22, 1, 0.36, 1)';
      el.style.height = to + 'px';

      var done = function (event) {
        if (event && event.target !== el) return;
        el.style.transition = '';
        el.style.height = '';
        el.removeEventListener('transitionend', done);
        window.clearTimeout(timer);
        after && after();
      };
      el.addEventListener('transitionend', done);
      // If the transition never fires, do not leave the panel pinned to a height.
      var timer = window.setTimeout(done, DURATION + 120);
    }

    function open() {
      if (details.open) return;
      details.open = true;
      if (reduced()) return;
      animate(body, 0, body.scrollHeight);
    }

    function close(instant) {
      if (!details.open) return;
      if (instant || reduced()) {
        details.open = false;
        return;
      }
      // Measured before the collapse starts, while the panel is still open.
      animate(body, body.scrollHeight, 0, function () {
        details.open = false;
      });
    }

    summary.addEventListener('click', function (event) {
      // The browser would toggle `open` immediately and skip the animation.
      event.preventDefault();

      if (details.open) {
        close();
        return;
      }

      siblings().forEach(function (other) {
        if (other.paClose) other.paClose();
      });
      open();
    });

    wrap.paClose = close;
  }

  function scan(scope) {
    (scope || document)
      .querySelectorAll('.product__accordion')
      .forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Section re-renders (variant changes) replace this markup wholesale.
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
